import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { contactInfo } from '../data/translations';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Contact = () => {
  const { t } = useLanguage();

  const contactItems = [
    {
      icon: MapPin,
      label: t.contact.address,
      value: contactInfo.address,
      color: 'bg-sky-100 text-sky-500'
    },
    {
      icon: Phone,
      label: t.contact.phone,
      value: contactInfo.phone,
      color: 'bg-cyan-100 text-cyan-500'
    },
    {
      icon: Mail,
      label: t.contact.email,
      value: contactInfo.email,
      color: 'bg-blue-100 text-blue-500'
    },
    {
      icon: Clock,
      label: t.contact.workHours,
      value: t.contact.workHoursValue,
      color: 'bg-indigo-100 text-indigo-500'
    }
  ];

  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 bg-sky-100 text-sky-600 text-sm font-medium rounded-full mb-4">
            {t.contact.title}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-4">
            {t.contact.subtitle}
          </h2>
        </div>

        {/* Main Content */}
        <div className="max-w-4xl mx-auto">
          {/* Contact Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            {contactItems.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-5 shadow-sm hover:shadow-lg transition-all duration-300 group border border-slate-100"
              >
                <div className={`w-12 h-12 ${item.color.split(' ')[0]} rounded-xl flex items-center justify-center mb-3`}>
                  <item.icon className={`w-6 h-6 ${item.color.split(' ')[1]}`} />
                </div>
                <h3 className="font-semibold text-slate-700 mb-1 text-sm">{item.label}</h3>
                <p className="text-slate-600 group-hover:text-sky-600 transition-colors text-sm">{item.value}</p>
              </div>
            ))}
          </div>

          {/* Google Maps */}
          <div className="relative rounded-2xl h-64 sm:h-80 overflow-hidden shadow-lg">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d721.6912711618054!2d49.973611840630014!3d40.401337676554576!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4030630078e69ca3%3A0x4844c1773995bbe7!2zxLBuZm9MYWIgVMmZZHJpcyBNyZlya8mZemk!5e1!3m2!1saz!2saz!4v1775466047449!5m2!1saz!2saz"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="InfoLab Location"
            />
            
              href="https://www.google.com/maps/place/InfoLab+T%C9%99dris+M%C9%99rk%C9%99zi/@40.401337676554576,49.973611840630014,18z"
              target="_blank"
              rel="noopener noreferrer"
              className="absolute inset-0 md:hidden"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
